import React, { useEffect, useState } from "react";
import { AddFlex, CustomText } from "../../reusableStyles";
import InstaLogo from "../../ImageAssets/insta_logo.png";
import styled from "styled-components";
import { primaryActionColor } from "../../constants";
import { handleOpenInNew, isNullOrUndefined, isValidImage } from "../../utils";
import user from "../../ImageAssets/user.jpg";
import { Tag } from "antd";

export const UsernameText = styled(CustomText)`
  &:hover {
    color: ${primaryActionColor};
  }
`;

function InstagramContactNameAndUsername({ data, column, index }) {
  const [image, setImage] = useState("");
  const { name, username, profile_pic, capturedDate, isNewFollower } =
    data(index);

  function isWithinLast24Hours() {
    const date = new Date(capturedDate);
    const now = new Date(); // Current date and time
    const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 24 hours ago

    // Check if the dateToCheck is within the last 24 hours
    return date > twentyFourHoursAgo && date <= now;
  }

  useEffect(() => {
    async function getProfilePic() {
      if (isNullOrUndefined(profile_pic)) {
        setImage(user);
      } else {
        const result = await isValidImage(profile_pic);
        if (result) {
          setImage(profile_pic);
        } else {
          setImage(user);
        }
      }
    }
    getProfilePic();
  }, []);

  return (
    <AddFlex style={{ flexGrow: 1, flexBasis: column.spacing }}>
      <AddFlex gap="10px">
        <img
          src={image}
          style={{ width: "40px", height: "40px", borderRadius: "50%" }}
        />
        <AddFlex alignItems="flex-start" flexDirection="column" gap="3px">
          {isNewFollower && isWithinLast24Hours() && (
            <Tag color="purple" small>
              New Follower
            </Tag>
          )}
          <CustomText color="black">{name || "Instagram User"}</CustomText>
          {username && (
            <AddFlex gap="4px" alignItems="center">
              <img src={InstaLogo} style={{ width: "15px", aspectRatio: 1 }} />
              <UsernameText
                color="black"
                fontSize="14px"
                onClick={() => {
                  handleOpenInNew(`https://instagram.com/${username}`);
                }}
              >
                {username}
              </UsernameText>
            </AddFlex>
          )}
        </AddFlex>
      </AddFlex>
    </AddFlex>
  );
}

export default InstagramContactNameAndUsername;
